/**
 * SurfaceStep — Substrate selection (renamed "Surface" for user-facing copy).
 * Renders medium-appropriate surface options as radio cards.
 */

import { T } from '@/styles/tokens';
import { StepNextButton } from './StepNextButton';
import { SectionIcon } from './SectionIcons';
import { getSubstrateOptions } from '@/constants/substrates';
import type { MediumKey } from '@/types/medium';

interface SurfaceStepProps {
  medium: MediumKey;
  substrate: string;
  onChangeSubstrate: (key: string) => void;
  onNext: () => void;
}

const cardStyle: React.CSSProperties = {
  background: T.white,
  borderRadius: 16,
  border: `1px solid ${T.cream200}`,
  padding: 20,
  boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
};

export function SurfaceStep({ medium, substrate, onChangeSubstrate, onNext }: SurfaceStepProps) {
  const options = getSubstrateOptions(medium);

  return (
    <div>
      <SectionIcon icon="surface" label="Surface" />
      <div style={cardStyle}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          {options.map((opt) => {
            const selected = substrate === opt.key;
            return (
              <label
                key={opt.key}
                onClick={() => onChangeSubstrate(opt.key)}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 10,
                  padding: '10px 12px',
                  borderRadius: 10,
                  cursor: 'pointer',
                  background: selected ? T.tealSoft : 'transparent',
                  border: `1px solid ${selected ? T.primary : T.cream200}`,
                  transition: 'all 0.15s ease',
                }}
              >
                <input
                  type="radio"
                  name="surface"
                  checked={selected}
                  onChange={() => onChangeSubstrate(opt.key)}
                  style={{ accentColor: T.primary, width: 16, height: 16 }}
                />
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: selected ? 600 : 400,
                    color: selected ? T.text : T.charcoal600,
                    fontFamily: T.fontFamily,
                  }}
                >
                  {opt.label}
                </span>
              </label>
            );
          })}
        </div>
        <StepNextButton label="Next" disabled={false} onPress={onNext} />
      </div>
    </div>
  );
}
